import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { useChooseOrderPrimaryContact } from '~/api/primaryContact';
import { PrimaryContactModal } from '~/components/common/PrimaryContactModal';
import { Button } from '~/components/ui';
import type { RecipientOrganization } from '~/utils/contact';

type AddOrderContactButtonProps = Readonly<{
  orderId: string;
  sellingOrganization: RecipientOrganization;
}>;

export function AddOrderContactButton({
  orderId,
  sellingOrganization,
}: AddOrderContactButtonProps) {
  const { t } = useTranslation('order');
  const [isOpen, setIsOpen] = useState(false);
  const { mutateAsync: chooseOrderPrimaryContact, isPending: isSaving } =
    useChooseOrderPrimaryContact();

  const save = async (userId: string) => {
    await chooseOrderPrimaryContact({ orderId, userId });
    toast.success(t('order.order_contact_modal.saved'));
  };

  return (
    <>
      <Button
        variant="secondary"
        size="sm"
        width="auto"
        onClick={() => setIsOpen(true)}
        data-testid="add-order-contact-button"
      >
        {t('order.add_contact_button')}
      </Button>
      {isOpen && (
        <PrimaryContactModal
          onClose={() => setIsOpen(false)}
          sellingOrganization={sellingOrganization}
          subtitle={t('order.order_contact_modal.subtitle')}
          isSaving={isSaving}
          save={save}
        />
      )}
    </>
  );
}
